<template>
    <div
            class="server-tile relative border border-gray-700 bg-gray-800 p-4 rounded-lg shadow-md animate-pulse overflow-hidden"
    >
        <!-- Top Section: Rank / Featured Placeholder -->
        <div class="content-center m-lg:mb-3 mb-3">
            <div class="flex justify-center px-1 gap-3">
                <!-- Placeholder for Rank Number or Star Icon -->
                <div class="h-8 w-8 bg-gray-600 rounded-full"></div>
                <!-- Placeholder for potential Sponsor Badge (Mobile) -->
                <div class="h-6 w-16 bg-gray-600 rounded lg:hidden"></div>
            </div>
        </div>

        <div class="m-lg:flex m-lg:flex-col m-lg:items-center m-lg:gap-2">
            <!-- Server Title/Icon Placeholder -->
            <div class="flex gap-2 mb-2 items-center">
                <!-- Icon Placeholder -->
                <div class="w-5 h-5 bg-gray-600 rounded m-lg:w-6 m-lg:h-6"></div>
                <!-- Title Placeholder -->
                <div class="h-5 bg-gray-600 rounded w-3/5 m-lg:h-6"></div>
                <!-- Sponsor Badge Placeholder (Desktop) -->
                <div class="h-5 w-16 bg-gray-600 rounded m-lg:hidden ml-auto"></div>
            </div>

            <!-- Banner Placeholder -->
            <div class="w-full h-24 bg-gray-600 rounded-lg mb-2 m-lg:h-32"></div>

            <!-- Desktop Badges Placeholder -->
            <div class="hidden justify-between mt-1.5 m-lg:flex m-lg:w-full m-lg:px-2">
                <!-- Platform Badge Placeholder -->
                <div class="h-5 w-20 bg-gray-600 rounded"></div>
                <!-- IP Badge Placeholder -->
                <div class="h-5 w-24 bg-gray-600 rounded"></div>
            </div>
        </div>

        <div>
            <!-- Desktop Players Badge Placeholder -->
            <div class="hidden justify-end mb-2 m-lg:flex">
                <!-- Players Badge Placeholder -->
                <div class="h-5 w-20 bg-gray-600 rounded"></div>
            </div>

            <!-- Description Placeholder -->
            <div class="space-y-2 pl-2 mb-3">
                <div class="h-3 bg-gray-600 rounded w-full"></div>
                <div class="h-3 bg-gray-600 rounded w-5/6"></div>
                <div class="h-3 bg-gray-600 rounded w-4/6"></div>
            </div>

            <!-- Mobile Badges Placeholder -->
            <div class="lg:hidden flex justify-end m-lg:justify-center m-lg:gap-4 m-lg:my-4 mb-3 gap-3">
                <!-- Players Badge Placeholder -->
                <div class="h-5 w-20 bg-gray-600 rounded"></div>
                <!-- Platform Badge Placeholder -->
                <div class="h-5 w-20 bg-gray-600 rounded"></div>
            </div>
            <div class="lg:hidden w-full flex justify-center mb-4">
                <!-- IP Badge Placeholder -->
                <div class="h-7 w-28 bg-gray-600 rounded-lg"></div>
            </div>

            <!-- Action Buttons Placeholder -->
            <div class="flex justify-end gap-3 m-lg:justify-center m-lg:mt-2 m-lg:mx-3">
                <!-- Edit/View Button Placeholder 1 -->
                <div class="h-8 w-20 bg-gray-600 rounded-2xl m-lg:h-9 m-lg:w-full"></div>
                <!-- View Button Placeholder 2 -->
                <div class="h-8 w-20 bg-gray-600 rounded-2xl m-lg:h-9 m-lg:w-full"></div>
            </div>
        </div>
    </div>
</template>

<script setup>
// No script logic needed for a static skeleton component
</script>

<style scoped>
/* Add any specific styles for the skeleton if needed, */
/* although Tailwind utilities usually suffice. */
/* Ensure the pulse animation looks good */
.animate-pulse {
    animation: pulse 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes pulse {
    0%, 100% {
        opacity: 1;
    }
    50% {
        opacity: .5;
    }
}

/* Mimic original tile styles */
.server-tile {
    background-color: rgba(45, 55, 72, 0.1); /* Adjust to match your theme's dark background */
    border: none;
    color: #a0aec0; /* Placeholder text color (though not visible) */
    padding: 1rem; /* Adjust padding */
    border-radius: 0.5rem; /* Adjust rounding */
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}
</style>